import { Action } from '@ngrx/store';
// eslint-disable-next-line max-len
import { VehicleTemplateDetail } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { VehicleTemplateDetailQueryParameters } from '@quorum/models/xs-query';

export const GET_TEMPLATE_DETAIL_FROM_SERVER = '[VEHICLE_MAINTENANCE] Get Template Detail From Server';
export class GetTemplateDetailsFromServer implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_TEMPLATE_DETAIL_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { params: VehicleTemplateDetailQueryParameters; vehicleId: number }) {}
}

export const GET_TEMPLATE_DETAIL_FROM_SERVER_SUCCESS = '[VEHICLE_MAINTENANCE] Get Template Detail From Server Success';
export class GetTemplateDetailFromServerSuccess implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_TEMPLATE_DETAIL_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { templateDetail: VehicleTemplateDetail[] }) {}
}

export const GET_TEMPLATE_DETAIL_FROM_SERVER_FAILURE = '[VEHICLE_MAINTENANCE] Get Template Detail From Server Failure';
export class GetTemplatedetailFromServerFailure implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = GET_TEMPLATE_DETAIL_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const CLEAR_TEMPLATE_DETAIL_IN_STATE = '[VEHICLE_MAINTENANCE] Clear Template Detail State';
export class ClearTemplateDetailInState implements Action {
  readonly feature = 'vehicleMaintenance';
  readonly type = CLEAR_TEMPLATE_DETAIL_IN_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: any) {}
}

export type TemplateDetailAction =
  | GetTemplateDetailsFromServer
  | GetTemplateDetailFromServerSuccess
  | GetTemplatedetailFromServerFailure
  | ClearTemplateDetailInState;
